import { useEffect, useState } from 'react';
import { generateMediaQuery } from './generateMediaQuery.js';
import { MediaQueryCache } from './MediaQueryCache.js';
export const useMediaQuery = (breakpoint, options = {}) => {
    const cacheKey = `${breakpoint}_${JSON.stringify(options)}`;
    let mediaQuery = MediaQueryCache.get(cacheKey);
    if (!mediaQuery) {
        const mediaQueryString = generateMediaQuery(breakpoint, options);
        // for SSR apps
        if (typeof window === 'undefined') {
            mediaQuery = {
                matches: false,
                media: mediaQueryString,
            };
        }
        else {
            mediaQuery = window.matchMedia(mediaQueryString);
        }
        MediaQueryCache.set(cacheKey, mediaQuery);
    }
    const [isMediaQueryMatching, setIsMediaQueryMatching] = useState(mediaQuery.matches);
    useEffect(() => {
        const handler = (event) => setIsMediaQueryMatching(event.matches);
        mediaQuery?.addListener(handler);
        return () => mediaQuery?.removeListener(handler);
    }, [mediaQuery]);
    return isMediaQueryMatching;
};
